/* =========================================================
   bd-contact-page.js
   The contact form is posted NORMALLY to Shopify (no fetch / AJAX),
   so Shopify can run its spam protection and e-mail the message.
   This file only adds small extras:
   - sender name for the e-mail
   - "sending…" state on the button (double-click protection)
   - scroll to the success / error message
   ========================================================= */

(function () {
  'use strict';

  var form = document.getElementById('bd-contact-form');


  /* ---- form extras (never blocks the submit) ---- */

  if (form) {

    var submitBtn = form.querySelector('#bd-contact-submit');
    var nameField = form.querySelector('[data-bd-contact-name]');
    var firstName = form.querySelector('[name="contact[first_name]"]');
    var lastName = form.querySelector('[name="contact[last_name]"]');

    form.addEventListener('submit', function () {

      /* Shopify shows contact[name] as the sender in the e-mail */
      if (nameField) {
        nameField.value = [
          firstName ? firstName.value.trim() : '',
          lastName ? lastName.value.trim() : ''
        ].join(' ').trim();
      }

      /* the browser has already validated the form when this event fires */
      if (submitBtn) {

        submitBtn.classList.add('is-loading');

        window.setTimeout(function () {
          submitBtn.disabled = true;
        }, 0);

      }

    });

    /* back button / bfcache: make the button usable again */
    window.addEventListener('pageshow', function () {

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      }

    });

  }


  /* ---- show the success / error message ---- */

  var notice = document.querySelector('[data-bd-contact-notice]');

  if (notice) {

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    notice.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'center'
    });

    try {
      notice.focus({ preventScroll: true });
    } catch (error) {
      notice.focus();
    }

  }

})();